
import React from "react";
import { Receipt, ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoExportProps {
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  format?: "square" | "horizontal";
  backgroundColor?: string;
  className?: string;
}

export function LogoExport({ 
  size = "xl", 
  format = "horizontal",
  backgroundColor = "transparent",
  className 
}: LogoExportProps) {
  const iconSizes = {
    sm: "h-8 w-8",
    md: "h-12 w-12", 
    lg: "h-16 w-16",
    xl: "h-24 w-24",
    "2xl": "h-32 w-32"
  };

  const textSizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-3xl", 
    xl: "text-5xl",
    "2xl": "text-6xl"
  };

  const overlayIconSizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8", 
    xl: "h-12 w-12",
    "2xl": "h-16 w-16"
  };

  const paddingSizes = {
    sm: "p-2",
    md: "p-3",
    lg: "p-4",
    xl: "p-6", 
    "2xl": "p-8"
  };

  const gapSizes = {
    sm: "gap-2",
    md: "gap-3",
    lg: "gap-4",
    xl: "gap-6",
    "2xl": "gap-8"
  };

  return (
    <div 
      className={cn(
        "flex items-center justify-center min-h-screen p-8",
        className
      )}
      style={{ backgroundColor }}
    >
      <div className={cn(
        "flex items-center",
        format === "square" ? "flex-col gap-4" : gapSizes[size]
      )}>
        <div className="relative">
          <div className="absolute inset-0 bg-primary/20 rounded-lg blur-sm"></div>
          <div className={cn(
            "relative flex items-center justify-center bg-gradient-to-br from-primary to-teal-500 text-white rounded-lg",
            paddingSizes[size]
          )}>
            <div className="relative flex">
              <Receipt className={cn("text-white", iconSizes[size])} />
              <ArrowLeft className={cn(
                "absolute -bottom-2 -right-2 text-amber-300",
                overlayIconSizes[size]
              )} />
            </div>
          </div>
        </div>
        
        <span className={cn(
          "font-extrabold tracking-tight bg-gradient-to-br from-primary to-teal-500 bg-clip-text text-transparent",
          textSizes[size]
        )}>
          SnapRefund
        </span>
      </div>
    </div>
  );
}
